export const TEXT_COPIED_TO_CLIPBOARD = 'Copied to clipboard';
export const TEXT_BASE_ERROR = 'Something went wrong';
export const TEXT_UPDATE_SUCESS = 'Successfully updated';
export const TEXT_CREATE_SUCESS = 'Successfully created';
export const TEXT_DELETE_SUCESS = 'Successfully deleted';
export default {};
